(function($) {

    // Accepted additional formats [here, allow for example "4/7/18" for "July 4, 2018"]
    // y = year (two digit); yy = year (four digit)
    $.datepicker.additionalFormats = ["mm/dd/y", "m/d/yy"];

    // Backup the original parsing function
    $.datepicker.originalParseDate = $.datepicker.parseDate;

    // New parsing function
    $.datepicker.parseDate = function (format, value, settings) {
        // Initialise the returned date
        var date;
        
        // Function that returns a date based on an input format
        function testParse(inputFormat) {
            try {
                // Try to get the date based on the input format
                date = $.datepicker.originalParseDate(inputFormat, value, settings);
                // If the date is right, returns it immediately
                return date;
            }
            catch (Error) {
                // _RD Bad date (this line does nothing but catching the error)
            }
        }

       

        // Don't bother with empty values
        if (value !== "0" && value !== "") {

            // Test the main datepicker format (which is an argument of this function)
            testParse(format);

            // If the main datepicker format didn't work, try with the additional ones
            for (var n = 0; n < $.datepicker.additionalFormats.length; n++) {
                testParse($.datepicker.additionalFormats[n]);
            }
        }

        // If the input string couldn't be parsed, returns just the "undefined"-typed variable
        return date;
    };

    // overwrite datepicker functionality
    $.datepicker._generateMonthYearHeader = function(inst, drawMonth, drawYear, minDate, maxDate, secondary, monthNames, monthNamesShort) {

        var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
            changeMonth = this._get(inst, 'changeMonth'),
            changeYear = this._get(inst, 'changeYear'),
            showMonthAfterYear = this._get(inst, 'showMonthAfterYear'),
            html = '<div class="ui-datepicker-title">',
            monthHtml = '';

        // month selection
        if (secondary || !changeMonth) {
            monthHtml += '<span class="ui-datepicker-month">' + monthNames[drawMonth] + '</span>';
        } else {
            inMinYear = (minDate && minDate.getFullYear() === drawYear);
            inMaxYear = (maxDate && maxDate.getFullYear() === drawYear);
            monthHtml += '<label><span class="sr-only">Select a month</span> <select class="ui-datepicker-month" data-handler="selectMonth" data-event="change">';
            for (month = 0; month < 12; month++) {
                if ((!inMinYear || month >= minDate.getMonth()) && (!inMaxYear || month <= maxDate.getMonth())) {
                    monthHtml += '<option value="' + month + '"' +
                        (month === drawMonth ? ' selected="selected"' : '') +
                        '>' + monthNamesShort[month] + '</option>';
                }
            }
            monthHtml += '</select></label>';
        }

        if (!showMonthAfterYear) {
            html += monthHtml + (secondary || !(changeMonth && changeYear) ? '&#xa0;' : '');
        }

        // year selection
        if (!inst.yearshtml) {
            inst.yearshtml = '';
            if (secondary || !changeYear) {
                html += '<span class="ui-datepicker-year">' + drawYear + '</span>';
            } else {
                // determine range of years to display
                years = this._get(inst, 'yearRange').split(':');
                thisYear = new Date().getFullYear();
                determineYear = function(value) {
                    var year = (value.match(/c[+\-].*/) ? drawYear + parseInt(value.substring(1), 10) :
                        (value.match(/[+\-].*/) ? thisYear + parseInt(value, 10) :
                            parseInt(value, 10)));
                    return (isNaN(year) ? thisYear : year);
                };
                year = determineYear(years[0]);
                endYear = Math.max(year, determineYear(years[1] || ''));
                year = (minDate ? Math.max(year, minDate.getFullYear()) : year);
                endYear = (maxDate ? Math.min(endYear, maxDate.getFullYear()) : endYear);
                inst.yearshtml += '<label><span class="sr-only">Select a year</span> <select class="ui-datepicker-year" data-handler="selectYear" data-event="change">';
                for (; year <= endYear; year++) {
                    inst.yearshtml += '<option value="' + year + '"' +
                        (year === drawYear ? ' selected="selected"' : '') +
                        '>' + year + '</option>';
                }
                inst.yearshtml += '</select></label>';

                html += inst.yearshtml;
                inst.yearshtml = null;
            }
        }

        html += this._get(inst, 'yearSuffix');
        if (showMonthAfterYear) {
            html += (secondary || !(changeMonth && changeYear) ? '&#xa0;' : '') + monthHtml;
        }
        html += '</div>'; // Close datepicker_header
        return html;
    };

})(jQuery);
